<template>
  <ak-modal-body>
    <ak-modal-title>Popout Export</ak-modal-title>
    <ak-code-editor v-model="code" language="html" />
  </ak-modal-body>
  <ak-modal-footer>
    <ak-modal-button type="submit">Okay</ak-modal-button>
  </ak-modal-footer>
</template>

<script>
import ModalTitle from '@akerolabs/akero-vue/src/components/modal/ModalTitle.vue'
import ModalBody from '@akerolabs/akero-vue/src/components/modal/ModalBody.vue'
import ModalFooter from '@akerolabs/akero-vue/src/components/modal/ModalFooter.vue'
import ModalButton from '@akerolabs/akero-vue/src/components/modal/ModalButton.vue'
import CodeEditor from '@akerolabs/akero-vue/src/components/codeEditor/CodeEditor.vue'
import { getExport, defaultOptions } from './helpers'
import { defineComponent, onMounted, ref } from 'vue'

export default defineComponent({
  name: 'AkPopoutExportModal',

  components: {
    [ModalTitle.name]: ModalTitle,
    [ModalBody.name]: ModalBody,
    [ModalFooter.name]: ModalFooter,
    [ModalButton.name]: ModalButton,
    [CodeEditor.name]: CodeEditor,
  },

  props: {
    modelValue: {
      type: Object,
      default: () => defaultOptions,
    },
  },

  setup(props) {
    const code = ref(undefined)

    onMounted(() => {
      code.value = getExport(props.modelValue)
    })

    return {
      code,
    }
  },
})
</script>
